import React from "react";
import mainImg from "./assets/criteria-8.2.jpg";

export default function Desktop() {
  return (
    <div className="layout-pic desktop">
      <div className="wrapper">
        <div className="main-img">
          <img src={mainImg} alt="" />
        </div>
        <div className="text-container">
          <div class="text-wrapper">
            <div class="excerpt1">
              <span>Gracias por confiar en nosotros</span>
            </div>
          </div>
        </div>
      </div>
      <div className="text-bottom">
        <div class="excerpt1">
          Verifica tu información y te contactaremos en breve
        </div>
        <div class="phone">
          <div>(33) 2100 - 6731</div>
        </div>
      </div>
    </div>
  );
}
